import { defineStore } from 'pinia';
import { authApi } from '@/services/api';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('getlokal_admin_token') || null,
    user: JSON.parse(localStorage.getItem('getlokal_admin_user')) || null,
    loading: false,
    error: null
  }),

  getters: {
    isAuthenticated: (state) => !!state.token,
    currentUser: (state) => state.user,
    userName: (state) => state.user?.name || 'Admin',
    userEmail: (state) => state.user?.email || '',
    userRoles: (state) => state.user?.roles || [],
    isSuperAdmin: (state) => state.user?.is_super_admin === true,
    isCompanyOwner: (state) => state.user?.is_company_owner === true,
    hasCompany: (state) => !!state.user?.company_id
  },

  actions: {
    async login(email, password) {
      this.loading = true;
      this.error = null;

      try {
        const response = await authApi.login(email, password);

        if (response.data.success) {
          const { token, admin } = response.data.data;

          // Store in state
          this.token = token;
          this.user = admin;

          // Persist to localStorage
          localStorage.setItem('getlokal_admin_token', token);
          localStorage.setItem('getlokal_admin_user', JSON.stringify(admin));

          return { success: true };
        } else {
          this.error = response.data.message || 'Login failed';
          return { success: false, message: this.error };
        }
      } catch (error) {
        const message = error.response?.data?.message
          || error.response?.data?.errors?.email?.[0]
          || 'Unable to connect to server';
        this.error = message;
        return { success: false, message };
      } finally {
        this.loading = false;
      }
    },

    async logout() {
      try {
        await authApi.logout();
      } catch (error) {
        console.error('Logout error:', error);
      } finally {
        this.clearAuth();
      }
    },

    clearAuth() {
      this.token = null;
      this.user = null;
      this.error = null;
      localStorage.removeItem('getlokal_admin_token');
      localStorage.removeItem('getlokal_admin_user');
    },

    checkAuth() {
      const token = localStorage.getItem('getlokal_admin_token');
      const user = localStorage.getItem('getlokal_admin_user');

      if (token && user) {
        this.token = token;
        this.user = JSON.parse(user);
        return true;
      }
      return false;
    }
  }
});
